export default "__VITE_ASSET__f269e626__"